// import { useEffect, useMemo, useState } from "react";
// import { db, storage } from "../../firebase";
// import {
//   collection,
//   doc,
//   getDoc,
//   onSnapshot,
//   orderBy,
//   query,
//   serverTimestamp,
//   setDoc,
//   where,
// } from "firebase/firestore";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { toast } from "react-hot-toast";
// import {
//   CheckCircle2,
//   Clock,
//   Image as ImageIcon,
//   Search,
//   UploadCloud,
//   X,
//   Banknote,
//   User as UserIcon,
//   Layers,
// } from "lucide-react";

// /* ───────── helpers ───────── */
// const money = (n, sym = "Rs") =>
//   isFinite(Number(n)) ? `${sym}${Number(n).toFixed(2)}` : `${sym}0.00`;
// const ts = (v) => v?.toDate?.()?.toLocaleString?.() || "";
// const symOf = (c) =>
//   c === "USD"
//     ? "$"
//     : c === "EUR"
//     ? "€"
//     : c === "GBP"
//     ? "£"
//     : c === "INR"
//     ? "₹"
//     : "Rs";

// /** which field on a card doc identifies its owner agent */
// function getOwnerUid(cardData) {
//   return (
//     cardData?.agentUid ||
//     cardData?.ownerUid ||
//     cardData?.createdBy ||
//     cardData?.sellerUid ||
//     null
//   );
// }

// // winners embedded in a drawn card (keeps ownerUid)
// function flattenCardWinnersFromOwnedCard(cardSnap) {
//   const c = { id: cardSnap.id, ...cardSnap.data() };
//   const arr = Array.isArray(c.winners) ? c.winners : [];
//   return arr
//     .filter((w) => w && w.userUid && w.ticketId)
//     .map((w) => ({
//       key: `${c.id}_${w.ticketId}`,
//       cardId: c.id,
//       drawnAt: c.drawnAt || c.drawDate || c.updatedAt || null,
//       winningNumber: c.winningNumber,
//       ownerUid: getOwnerUid(c),
//       userUid: w.userUid,
//       ticketId: w.ticketId,
//       amount: Number(w.amount ?? w.winAmount ?? 0),
//       currency: w.currency || c.currency || "LKR",
//     }));
// }

// export default function AgentWinners({ user }) {
//   const [raw, setRaw] = useState([]); // winners for THIS agent only
//   const [banksByUser, setBanksByUser] = useState({}); // uid -> { bank, displayName, email, phone... }
//   const [payoutsByKey, setPayoutsByKey] = useState({}); // key -> payout doc
//   const [search, setSearch] = useState("");

//   // drawers + form
//   const [drawer, setDrawer] = useState(null);
//   const [note, setNote] = useState("");
//   const [uploading, setUploading] = useState(false);

//   // tabs
//   const [currentTab, setCurrentTab] = useState("unpaid"); // 'unpaid' | 'paid'
//   const [prevTab, setPrevTab] = useState("unpaid"); // 'unpaid' | 'paid'

//   /* 1) Watch drawn cards that belong to THIS agent and flatten winners */
//   useEffect(() => {
//     if (!user?.uid) return;

//     let qCards;
//     // Best: server-side filter by agentUid. If your cards use a different field,
//     // switch it here and add a composite index in Firestore if prompted.
//     try {
//       qCards = query(
//         collection(db, "cards"),
//         where("status", "==", "drawn"),
//         where("agentUid", "==", user.uid),
//         orderBy("drawnAt", "desc")
//       );
//     } catch {
//       // Fallback when index/field isn't available: filter client-side.
//       qCards = query(
//         collection(db, "cards"),
//         where("status", "==", "drawn"),
//         orderBy("drawnAt", "desc")
//       );
//     }

//     const unsub = onSnapshot(
//       qCards,
//       (snap) => {
//         const mine = [];
//         snap.forEach((d) => {
//           const owner = getOwnerUid(d.data());
//           if (owner === user.uid) {
//             mine.push(...flattenCardWinnersFromOwnedCard(d));
//           }
//         });
//         setRaw(mine);
//       },
//       (err) => {
//         console.error("[AgentWinners] cards error", err);
//         toast.error("Failed to load winners");
//       }
//     );
//     return () => unsub();
//   }, [user?.uid]);

//   /* 2) Compute latest draw boundary */
//   const latestDrawMs = useMemo(() => {
//     let max = 0;
//     for (const w of raw) {
//       const ms = w.drawnAt?.toDate?.()?.getTime?.() || 0;
//       if (ms > max) max = ms;
//     }
//     return max || 0;
//   }, [raw]);

//   const [currentWinners, previousWinners] = useMemo(() => {
//     if (!latestDrawMs) return [[], raw];
//     const cur = [];
//     const prev = [];
//     for (const w of raw) {
//       const ms = w.drawnAt?.toDate?.()?.getTime?.() || 0;
//       if (ms === latestDrawMs) cur.push(w);
//       else prev.push(w);
//     }
//     return [cur, prev];
//   }, [raw, latestDrawMs]);

//   /* 3) Load banks (first bank) + contact for all users shown */
//   useEffect(() => {
//     const uids = Array.from(
//       new Set([...currentWinners, ...previousWinners].map((w) => w.userUid))
//     );
//     if (!uids.length) return;

//     (async () => {
//       const next = {};
//       await Promise.all(
//         uids.map(async (uid) => {
//           try {
//             const s = await getDoc(doc(db, "users", uid));
//             if (s.exists()) {
//               const d = s.data();
//               const bank =
//                 Array.isArray(d.banks) && d.banks.length ? d.banks[0] : null;

//               const email = d.email || d.contactEmail || d.userEmail || "";
//               const phoneE164 = d.phoneE164 || null;
//               const digitsRaw = d.phone || d.mobile || d.userMobile || "";
//               const phoneDigits = String(digitsRaw || "").replace(/\D/g, "");

//               next[uid] = {
//                 bank,
//                 displayName: d.displayName || d.name || "",
//                 email,
//                 phoneE164,
//                 phoneDigits,
//               };
//             } else {
//               next[uid] = {
//                 bank: null,
//                 displayName: "",
//                 email: "",
//                 phoneE164: null,
//                 phoneDigits: "",
//               };
//             }
//           } catch {
//             next[uid] = {
//               bank: null,
//               displayName: "",
//               email: "",
//               phoneE164: null,
//               phoneDigits: "",
//             };
//           }
//         })
//       );
//       setBanksByUser(next);
//     })();
//   }, [currentWinners, previousWinners]);

//   /* 4) Load payout state for all winners (doc id = `${cardId}_${ticketId}`) */
//   useEffect(() => {
//     const keys = Array.from(
//       new Set([...currentWinners, ...previousWinners].map((w) => w.key))
//     );
//     if (!keys.length) return;

//     (async () => {
//       const next = {};
//       await Promise.all(
//         keys.map(async (k) => {
//           try {
//             const s = await getDoc(doc(db, "payouts", k));
//             if (s.exists()) next[k] = { id: s.id, ...s.data() };
//           } catch {
//             // ignore
//           }
//         })
//       );
//       setPayoutsByKey(next);
//     })();
//   }, [currentWinners, previousWinners]);

//   /* 5) Merge for rendering (and ignore payouts from other agents) */
//   function decorate(w) {
//     const p = payoutsByKey[w.key];
//     const u = banksByUser[w.userUid] || {};

//     const isMinePayout = !p || p.agentUid === user.uid; // belt & suspenders

//     return {
//       ...w,
//       playerName: u.displayName || u.phoneDigits || w.userUid,
//       playerEmail: u.email || "",
//       playerPhoneE164: u.phoneE164 || "",
//       playerPhoneDigits: u.phoneDigits || "",
//       bank: u.bank || null,
//       paid: isMinePayout ? !!p?.paid : false,
//       paidAt: isMinePayout ? p?.paidAt || null : null,
//       receiptUrl: isMinePayout ? p?.receiptUrl || "" : "",
//       savedNote: isMinePayout ? p?.note || "" : "",
//     };
//   }

//   const currentRows = useMemo(
//     () => currentWinners.map(decorate),
//     [currentWinners, payoutsByKey, banksByUser]
//   );
//   const previousRows = useMemo(
//     () => previousWinners.map(decorate),
//     [previousWinners, payoutsByKey, banksByUser]
//   );

//   // search helpers
//   const filterBySearch = (rows) => {
//     if (!search.trim()) return rows;
//     const q = search.trim().toLowerCase();
//     return rows.filter((r) => {
//       return (
//         r.playerName.toLowerCase().includes(q) ||
//         (r.playerEmail || "").toLowerCase().includes(q) ||
//         (r.playerPhoneE164 || r.playerPhoneDigits || "")
//           .toString()
//           .toLowerCase()
//           .includes(q) ||
//         (r.userUid || "").toLowerCase().includes(q) ||
//         (r.ticketId || "").toLowerCase().includes(q) ||
//         (r.cardId || "").toLowerCase().includes(q)
//       );
//     });
//   };

//   const currentFiltered = useMemo(
//     () => filterBySearch(currentRows),
//     [currentRows, search]
//   );
//   const previousFiltered = useMemo(
//     () => filterBySearch(previousRows),
//     [previousRows, search]
//   );

//   // split paid/unpaid
//   const curUnpaid = useMemo(
//     () => currentFiltered.filter((r) => !r.paid),
//     [currentFiltered]
//   );
//   const curPaid = useMemo(
//     () => currentFiltered.filter((r) => r.paid),
//     [currentFiltered]
//   );
//   const prevUnpaid = useMemo(
//     () => previousFiltered.filter((r) => !r.paid),
//     [previousFiltered]
//   );
//   const prevPaid = useMemo(
//     () => previousFiltered.filter((r) => r.paid),
//     [previousFiltered]
//   );

//   /* ───────── actions ───────── */
//   const uploadReceipt = async (file) => {
//     if (!drawer || !file || !user?.uid) return;
//     setUploading(true);
//     try {
//       const path = `payout_receipts/${user.uid}/${drawer.key}_${Date.now()}`;
//       const r = ref(storage, path);
//       await uploadBytes(r, file);
//       const url = await getDownloadURL(r);

//       await setDoc(
//         doc(db, "payouts", drawer.key),
//         {
//           agentUid: user.uid,
//           userUid: drawer.userUid,
//           cardId: drawer.cardId,
//           ticketId: drawer.ticketId,
//           amount: drawer.amount,
//           currency: drawer.currency,
//           receiptUrl: url,
//           note: note || drawer.savedNote || "",
//           paid: false,
//           updatedAt: serverTimestamp(),
//         },
//         { merge: true }
//       );

//       setDrawer((d) => ({ ...d, receiptUrl: url }));
//       toast.success("Receipt uploaded");
//     } catch (e) {
//       console.error(e);
//       toast.error("Upload failed");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const markAsPaid = async () => {
//     if (!drawer) return;
//     try {
//       await setDoc(
//         doc(db, "payouts", drawer.key),
//         {
//           agentUid: user.uid,
//           userUid: drawer.userUid,
//           cardId: drawer.cardId,
//           ticketId: drawer.ticketId,
//           amount: drawer.amount,
//           currency: drawer.currency,
//           note: note || drawer.savedNote || "",
//           paid: true,
//           paidAt: serverTimestamp(),
//           updatedAt: serverTimestamp(),
//         },
//         { merge: true }
//       );
//       toast.success("Marked as paid");
//       setDrawer(null);
//       setNote("");
//     } catch (e) {
//       console.error(e);
//       toast.error("Failed to mark as paid");
//     }
//   };

//   /* ───────── small UI atom ───────── */
//   const WinnerCard = ({ w, onClick }) => (
//     <button
//       onClick={onClick}
//       className="text-left p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700 hover:ring-slate-600 transition"
//     >
//       <div className="text-sm text-slate-300 flex items-center gap-2">
//         <UserIcon className="w-4 h-4" />
//         {w.playerName}
//       </div>
//       {/* Optional: show email/phone line */}
//       {w.playerEmail || w.playerPhoneE164 || w.playerPhoneDigits ? (
//         <div className="text-[11px] text-slate-400 break-all mt-0.5">
//           {w.playerEmail || "—"}
//           {" · "}
//           {w.playerPhoneE164 || w.playerPhoneDigits || "—"}
//         </div>
//       ) : null}

//       <div className="text-xl font-bold mt-1">
//         {money(w.amount, symOf(w.currency))}
//       </div>
//       <div className="mt-2 text-xs text-slate-400">
//         Ticket: <b>{(w.ticketId || "").slice(0, 8)}…</b> · Card:{" "}
//         <b>{(w.cardId || "").slice(0, 8)}…</b>
//       </div>
//       <div className="mt-2 text-xs text-slate-500">Drawn: {ts(w.drawnAt)}</div>
//       {w.bank ? (
//         <div className="mt-3 text-xs text-slate-300 flex items-center gap-2">
//           <Banknote className="w-4 h-4" />
//           {w.bank.bankName} · {w.bank.accountName} · {w.bank.accountNumber}
//         </div>
//       ) : (
//         <div className="mt-3 text-xs text-red-300">No bank on file</div>
//       )}
//     </button>
//   );

//   /* ───────── render ───────── */
//   return (
//     <div className="max-w-6xl mx-auto mt-8 md:mt-16 p-4">
//       <div className="flex items-center justify-between gap-3 mb-4">
//         <h1 className="text-2xl font-bold">Winners</h1>
//         <div className="relative">
//           <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//           <input
//             className="pl-9 pr-3 py-2 rounded-xl bg-slate-800 text-white ring-1 ring-slate-700 w-72"
//             placeholder="Search user, ticket, card…"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* CURRENT (latest draw) — with tabs */}
//       <section className="mb-10">
//         <div className="flex items-center justify-between mb-2">
//           <div className="flex items-center gap-2">
//             <Layers className="w-4 h-4 text-sky-300" />
//             <h2 className="text-lg font-semibold">
//               Current winners (latest draw)
//             </h2>
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => setCurrentTab("unpaid")}
//               className={`px-3 py-1.5 rounded-full text-sm ${
//                 currentTab === "unpaid"
//                   ? "bg-yellow-400 text-black"
//                   : "bg-slate-700 text-white"
//               }`}
//             >
//               Unpaid ({curUnpaid.length})
//             </button>
//             <button
//               onClick={() => setCurrentTab("paid")}
//               className={`px-3 py-1.5 rounded-full text-sm ${
//                 currentTab === "paid"
//                   ? "bg-emerald-400 text-black"
//                   : "bg-slate-700 text-white"
//               }`}
//             >
//               Paid ({curPaid.length})
//             </button>
//           </div>
//         </div>

//         {currentFiltered.length ? (
//           currentTab === "unpaid" ? (
//             curUnpaid.length ? (
//               <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
//                 {curUnpaid.map((w) => (
//                   <WinnerCard
//                     key={w.key}
//                     w={w}
//                     onClick={() => {
//                       setDrawer(w);
//                       setNote(w.savedNote || "");
//                     }}
//                   />
//                 ))}
//               </div>
//             ) : (
//               <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
//                 No unpaid winners in the latest draw.
//               </div>
//             )
//           ) : curPaid.length ? (
//             <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
//               {curPaid.map((w) => (
//                 <WinnerCard
//                   key={w.key}
//                   w={w}
//                   onClick={() => {
//                     setDrawer(w);
//                     setNote(w.savedNote || "");
//                   }}
//                 />
//               ))}
//             </div>
//           ) : (
//             <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
//               No paid winners recorded for the latest draw yet.
//             </div>
//           )
//         ) : (
//           <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
//             No winners in the latest draw yet.
//           </div>
//         )}
//       </section>

//       {/* PREVIOUS DRAWS — TABS */}
//       <section className="mb-8">
//         <div className="flex items-center justify-between mb-2">
//           <div className="flex items-center gap-2">
//             <Clock className="w-4 h-4 text-yellow-300" />
//             <h2 className="text-lg font-semibold">Previous draws</h2>
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => setPrevTab("unpaid")}
//               className={`px-3 py-1.5 rounded-full text-sm ${
//                 prevTab === "unpaid"
//                   ? "bg-yellow-400 text-black"
//                   : "bg-slate-700 text-white"
//               }`}
//             >
//               Unpaid ({prevUnpaid.length})
//             </button>
//             <button
//               onClick={() => setPrevTab("paid")}
//               className={`px-3 py-1.5 rounded-full text-sm ${
//                 prevTab === "paid"
//                   ? "bg-emerald-400 text-black"
//                   : "bg-slate-700 text-white"
//               }`}
//             >
//               Paid ({prevPaid.length})
//             </button>
//           </div>
//         </div>

//         {prevTab === "unpaid" ? (
//           prevUnpaid.length ? (
//             <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
//               {prevUnpaid.map((w) => (
//                 <WinnerCard
//                   key={w.key}
//                   w={w}
//                   onClick={() => {
//                     setDrawer(w);
//                     setNote(w.savedNote || "");
//                   }}
//                 />
//               ))}
//             </div>
//           ) : (
//             <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
//               No unpaid winners from previous draws.
//             </div>
//           )
//         ) : prevPaid.length ? (
//           <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
//             {prevPaid.map((w) => (
//               <WinnerCard
//                 key={w.key}
//                 w={w}
//                 onClick={() => {
//                   setDrawer(w);
//                   setNote(w.savedNote || "");
//                 }}
//               />
//             ))}
//           </div>
//         ) : (
//           <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
//             No paid winners recorded for previous draws yet.
//           </div>
//         )}
//       </section>

//       {/* Drawer */}
//       {drawer && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40"
//           onClick={() => setDrawer(null)}
//         >
//           <div
//             className="absolute right-0 top-0 h-full w-full max-w-md bg-slate-900 p-5 overflow-y-auto"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="flex items-center justify-between mb-3">
//               <div className="text-lg font-semibold">Winner details</div>
//               <button
//                 onClick={() => setDrawer(null)}
//                 className="p-2 rounded bg-slate-800 hover:bg-slate-700"
//               >
//                 <X size={18} />
//               </button>
//             </div>

//             <div className="space-y-2 text-sm text-slate-300">
//               <div className="space-y-0.5">
//                 <div>
//                   <b>Player:</b> {drawer.playerName}
//                 </div>
//                 <div className="text-slate-400 text-xs break-all">
//                   {drawer.playerEmail || "—"}
//                   {" · "}
//                   {drawer.playerPhoneE164 || drawer.playerPhoneDigits || "—"}
//                 </div>
//               </div>

//               <div>
//                 <b>Amount:</b> {money(drawer.amount, symOf(drawer.currency))}
//               </div>
//               <div>
//                 <b>Ticket:</b> {drawer.ticketId}
//               </div>
//               <div>
//                 <b>Card:</b> {drawer.cardId}
//               </div>
//               <div>
//                 <b>Drawn at:</b> {ts(drawer.drawnAt)}
//               </div>

//               <div className="mt-3">
//                 <div className="text-sm font-semibold mb-1">Bank details</div>
//                 {drawer.bank ? (
//                   <div className="p-3 rounded-xl bg-slate-800 ring-1 ring-slate-700 text-sm">
//                     <div>{drawer.bank.bankName}</div>
//                     <div>{drawer.bank.accountName}</div>
//                     <div>{drawer.bank.accountNumber}</div>
//                     {drawer.bank.branch ? (
//                       <div>{drawer.bank.branch}</div>
//                     ) : null}
//                   </div>
//                 ) : (
//                   <div className="text-red-300 text-sm">
//                     No bank on file for this user.
//                   </div>
//                 )}
//               </div>

//               <div className="mt-4">
//                 <div className="text-sm font-semibold mb-1">Payout receipt</div>
//                 <div className="p-3 rounded-xl bg-slate-800 ring-1 ring-slate-700">
//                   {drawer.receiptUrl ? (
//                     <a
//                       href={drawer.receiptUrl}
//                       target="_blank"
//                       rel="noreferrer"
//                       className="flex items-center gap-2 text-slate-300 hover:underline"
//                     >
//                       <ImageIcon size={16} />
//                       View current receipt
//                     </a>
//                   ) : (
//                     <div className="text-slate-400 text-sm">
//                       No receipt uploaded yet.
//                     </div>
//                   )}

//                   <label className="mt-3 inline-flex items-center gap-2 px-3 py-2 rounded bg-indigo-400 text-black font-semibold cursor-pointer">
//                     <UploadCloud size={16} />
//                     {uploading ? "Uploading…" : "Upload new"}
//                     <input
//                       type="file"
//                       accept="image/*"
//                       className="hidden"
//                       onChange={(e) =>
//                         e.target.files?.[0] &&
//                         (async () => {
//                           setUploading(true);
//                           try {
//                             const file = e.target.files[0];
//                             const path = `payout_receipts/${user.uid}/${
//                               drawer.key
//                             }_${Date.now()}`;
//                             const r = ref(storage, path);
//                             await uploadBytes(r, file);
//                             const url = await getDownloadURL(r);
//                             await setDoc(
//                               doc(db, "payouts", drawer.key),
//                               {
//                                 agentUid: user.uid,
//                                 userUid: drawer.userUid,
//                                 cardId: drawer.cardId,
//                                 ticketId: drawer.ticketId,
//                                 amount: drawer.amount,
//                                 currency: drawer.currency,
//                                 receiptUrl: url,
//                                 note: note || drawer.savedNote || "",
//                                 paid: drawer.paid || false,
//                                 updatedAt: serverTimestamp(),
//                               },
//                               { merge: true }
//                             );
//                             setDrawer((d) => ({ ...d, receiptUrl: url }));
//                             toast.success("Receipt uploaded");
//                           } catch (err) {
//                             console.error(err);
//                             toast.error("Upload failed");
//                           } finally {
//                             setUploading(false);
//                           }
//                         })()
//                       }
//                       disabled={uploading}
//                     />
//                   </label>
//                 </div>
//               </div>

//               <div className="mt-4">
//                 <div className="text-sm font-semibold mb-1">
//                   Note (optional)
//                 </div>
//                 <textarea
//                   className="w-full min-h-[80px] p-3 rounded-xl bg-slate-800 text-white ring-1 ring-slate-700"
//                   placeholder="e.g., Sent via bank transfer. Ref #1234"
//                   value={note}
//                   onChange={(e) => setNote(e.target.value)}
//                 />
//               </div>

//               <div className="mt-4 flex items-center gap-2">
//                 {!drawer.paid ? (
//                   <button
//                     onClick={async () => {
//                       try {
//                         await setDoc(
//                           doc(db, "payouts", drawer.key),
//                           {
//                             agentUid: user.uid,
//                             userUid: drawer.userUid,
//                             cardId: drawer.cardId,
//                             ticketId: drawer.ticketId,
//                             amount: drawer.amount,
//                             currency: drawer.currency,
//                             note: note || drawer.savedNote || "",
//                             paid: true,
//                             paidAt: serverTimestamp(),
//                             updatedAt: serverTimestamp(),
//                           },
//                           { merge: true }
//                         );
//                         toast.success("Marked as paid");
//                         setDrawer(null);
//                         setNote("");
//                       } catch (e) {
//                         console.error(e);
//                         toast.error("Failed to mark as paid");
//                       }
//                     }}
//                     className="px-4 py-2 rounded-xl bg-emerald-400 text-black font-semibold"
//                   >
//                     Mark as Paid & Save
//                   </button>
//                 ) : (
//                   <span className="px-2 py-1 rounded bg-emerald-500/20 text-emerald-300 text-sm">
//                     Already paid
//                   </span>
//                 )}
//                 <button
//                   onClick={() => setDrawer(null)}
//                   className="px-4 py-2 rounded-xl bg-slate-700 text-white"
//                 >
//                   Close
//                 </button>
//               </div>

//               <div className="text-xs text-slate-500 mt-3">
//                 Tip: upload a bank-slip or transaction screenshot before marking
//                 as paid.
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { db, storage } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  where,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { toast } from "react-hot-toast";
import {
  CheckCircle2,
  Clock,
  Image as ImageIcon,
  Search,
  UploadCloud,
  X,
  Banknote,
  User as UserIcon,
  Layers,
} from "lucide-react";

/* ───────── helpers ───────── */
const money = (n, sym = "Rs") =>
  isFinite(Number(n)) ? `${sym}${Number(n).toFixed(2)}` : `${sym}0.00`;
const ts = (v) => v?.toDate?.()?.toLocaleString?.() || "";
const symOf = (c) =>
  c === "USD"
    ? "$"
    : c === "EUR"
    ? "€"
    : c === "GBP"
    ? "£"
    : c === "INR"
    ? "₹"
    : "Rs";

/** card owner */
function getOwnerUid(cardData) {
  return (
    cardData?.agentUid ||
    cardData?.ownerUid ||
    cardData?.createdBy ||
    cardData?.sellerUid ||
    null
  );
}

/** winners embedded in card */
function flattenCardWinnersFromOwnedCard(cardSnap) {
  const c = { id: cardSnap.id, ...cardSnap.data() };
  const arr = Array.isArray(c.winners) ? c.winners : [];
  return arr
    .filter((w) => w && w.userUid && w.ticketId)
    .map((w) => ({
      key: `${c.id}_${w.ticketId}`,
      cardId: c.id,
      drawnAt: c.drawnAt || c.drawDate || c.updatedAt || null,
      winningNumber: c.winningNumber,
      ownerUid: getOwnerUid(c),
      userUid: w.userUid,
      ticketId: w.ticketId,
      amount: Number(w.amount ?? w.winAmount ?? 0),
      currency: w.currency || c.currency || "LKR",
    }));
}

/** sum helpers */
const sum = (xs, f = (x) => x) => xs.reduce((a, b) => a + f(b), 0);

/* ───────── component ───────── */
export default function AgentWinners({ user }) {
  const [raw, setRaw] = useState([]);
  const [banksByUser, setBanksByUser] = useState({});
  const [payoutsByKey, setPayoutsByKey] = useState({});
  const [search, setSearch] = useState("");

  // drawer state (supports single or group)
  const [drawer, setDrawer] = useState(null); // {mode:'single'|'group', ...}
  const [note, setNote] = useState("");
  const [uploading, setUploading] = useState(false);

  const [currentTab, setCurrentTab] = useState("unpaid");
  const [prevTab, setPrevTab] = useState("unpaid");

  /* 1) watch my drawn cards & flatten */
  useEffect(() => {
    if (!user?.uid) return;

    let qCards;
    try {
      qCards = query(
        collection(db, "cards"),
        where("status", "==", "drawn"),
        where("agentUid", "==", user.uid),
        orderBy("drawnAt", "desc")
      );
    } catch {
      qCards = query(
        collection(db, "cards"),
        where("status", "==", "drawn"),
        orderBy("drawnAt", "desc")
      );
    }

    const unsub = onSnapshot(
      qCards,
      (snap) => {
        const mine = [];
        snap.forEach((d) => {
          const owner = getOwnerUid(d.data());
          if (owner === user.uid) {
            mine.push(...flattenCardWinnersFromOwnedCard(d));
          }
        });
        setRaw(mine);
      },
      (err) => {
        console.error("[AgentWinners] cards error", err);
        toast.error("Failed to load winners");
      }
    );
    return () => unsub();
  }, [user?.uid]);

  /* 2) latest draw boundary */
  const latestDrawMs = useMemo(() => {
    let max = 0;
    for (const w of raw) {
      const ms = w.drawnAt?.toDate?.()?.getTime?.() || 0;
      if (ms > max) max = ms;
    }
    return max || 0;
  }, [raw]);

  const [currentWinners, previousWinners] = useMemo(() => {
    if (!latestDrawMs) return [[], raw];
    const cur = [];
    const prev = [];
    for (const w of raw) {
      const ms = w.drawnAt?.toDate?.()?.getTime?.() || 0;
      if (ms === latestDrawMs) cur.push(w);
      else prev.push(w);
    }
    return [cur, prev];
  }, [raw, latestDrawMs]);

  /* 3) load user profiles/banks */
  useEffect(() => {
    const uids = Array.from(
      new Set([...currentWinners, ...previousWinners].map((w) => w.userUid))
    );
    if (!uids.length) return;

    (async () => {
      const next = {};
      await Promise.all(
        uids.map(async (uid) => {
          try {
            const s = await getDoc(doc(db, "users", uid));
            if (s.exists()) {
              const d = s.data();
              const bank =
                Array.isArray(d.banks) && d.banks.length ? d.banks[0] : null;
              const email = d.email || d.contactEmail || d.userEmail || "";
              const phoneE164 = d.phoneE164 || null;
              const digitsRaw = d.phone || d.mobile || d.userMobile || "";
              const phoneDigits = String(digitsRaw || "").replace(/\D/g, "");
              next[uid] = {
                bank,
                displayName: d.displayName || d.name || "",
                email,
                phoneE164,
                phoneDigits,
              };
            } else {
              next[uid] = {
                bank: null,
                displayName: "",
                email: "",
                phoneE164: null,
                phoneDigits: "",
              };
            }
          } catch {
            next[uid] = {
              bank: null,
              displayName: "",
              email: "",
              phoneE164: null,
              phoneDigits: "",
            };
          }
        })
      );
      setBanksByUser(next);
    })();
  }, [currentWinners, previousWinners]);

  /* 4) load payouts */
  useEffect(() => {
    const keys = Array.from(
      new Set([...currentWinners, ...previousWinners].map((w) => w.key))
    );
    if (!keys.length) return;

    (async () => {
      const next = {};
      await Promise.all(
        keys.map(async (k) => {
          try {
            const s = await getDoc(doc(db, "payouts", k));
            if (s.exists()) next[k] = { id: s.id, ...s.data() };
          } catch {}
        })
      );
      setPayoutsByKey(next);
    })();
  }, [currentWinners, previousWinners]);

  /* 5) decorate */
  function decorate(w) {
    const p = payoutsByKey[w.key];
    const u = banksByUser[w.userUid] || {};
    const isMinePayout = !p || p.agentUid === user.uid;

    return {
      ...w,
      playerName: u.displayName || u.phoneDigits || w.userUid,
      playerEmail: u.email || "",
      playerPhoneE164: u.phoneE164 || "",
      playerPhoneDigits: u.phoneDigits || "",
      bank: u.bank || null,
      paid: isMinePayout ? !!p?.paid : false,
      paidAt: isMinePayout ? p?.paidAt || null : null,
      receiptUrl: isMinePayout ? p?.receiptUrl || "" : "",
      savedNote: isMinePayout ? p?.note || "" : "",
    };
  }

  const currentRows = useMemo(
    () => currentWinners.map(decorate),
    [currentWinners, payoutsByKey, banksByUser]
  );
  const previousRows = useMemo(
    () => previousWinners.map(decorate),
    [previousWinners, payoutsByKey, banksByUser]
  );

  /* search */
  const filterBySearch = (rows) => {
    if (!search.trim()) return rows;
    const q = search.trim().toLowerCase();
    return rows.filter((r) => {
      return (
        r.playerName.toLowerCase().includes(q) ||
        (r.playerEmail || "").toLowerCase().includes(q) ||
        (r.playerPhoneE164 || r.playerPhoneDigits || "")
          .toString()
          .toLowerCase()
          .includes(q) ||
        (r.userUid || "").toLowerCase().includes(q) ||
        (r.ticketId || "").toLowerCase().includes(q) ||
        (r.cardId || "").toLowerCase().includes(q)
      );
    });
  };
  const currentFiltered = useMemo(
    () => filterBySearch(currentRows),
    [currentRows, search]
  );
  const previousFiltered = useMemo(
    () => filterBySearch(previousRows),
    [previousRows, search]
  );

  /* split paid/unpaid */
  const curUnpaid = useMemo(
    () => currentFiltered.filter((r) => !r.paid),
    [currentFiltered]
  );
  const curPaid = useMemo(
    () => currentFiltered.filter((r) => r.paid),
    [currentFiltered]
  );
  const prevUnpaid = useMemo(
    () => previousFiltered.filter((r) => !r.paid),
    [previousFiltered]
  );
  const prevPaid = useMemo(
    () => previousFiltered.filter((r) => r.paid),
    [previousFiltered]
  );

  /* ───────── NEW: group unpaid by user & currency ───────── */
  function groupUnpaid(rows) {
    const map = new Map(); // key: `${userUid}|${currency}`
    for (const r of rows) {
      const k = `${r.userUid}|${r.currency}`;
      const entry = map.get(k) || {
        key: k,
        userUid: r.userUid,
        currency: r.currency,
        playerName: r.playerName,
        playerEmail: r.playerEmail,
        playerPhoneE164: r.playerPhoneE164,
        playerPhoneDigits: r.playerPhoneDigits,
        bank: r.bank,
        items: [], // individual tickets
        totalAmount: 0,
        lastDrawnAt: r.drawnAt,
      };
      entry.items.push(r);
      entry.totalAmount += Number(r.amount || 0);
      const tms = r.drawnAt?.toDate?.()?.getTime?.() || 0;
      const lms = entry.lastDrawnAt?.toDate?.()?.getTime?.() || 0;
      if (tms > lms) entry.lastDrawnAt = r.drawnAt;
      map.set(k, entry);
    }
    // newest first by last draw time
    return Array.from(map.values()).sort(
      (a, b) =>
        (b.lastDrawnAt?.toDate?.()?.getTime?.() || 0) -
        (a.lastDrawnAt?.toDate?.()?.getTime?.() || 0)
    );
  }

  const curUnpaidGrouped = useMemo(() => groupUnpaid(curUnpaid), [curUnpaid]);
  const prevUnpaidGrouped = useMemo(
    () => groupUnpaid(prevUnpaid),
    [prevUnpaid]
  );

  /* ───────── actions that work for single or group ───────── */

  async function uploadReceiptFor(mode, payload, file) {
    if (!file || !user?.uid) return;
    const path = `payout_receipts/${user.uid}/${payload.key}_${Date.now()}`;
    const r = ref(storage, path);
    await uploadBytes(r, file);
    const url = await getDownloadURL(r);

    if (mode === "single") {
      const w = payload.item;
      await setDoc(
        doc(db, "payouts", w.key),
        {
          agentUid: user.uid,
          userUid: w.userUid,
          cardId: w.cardId,
          ticketId: w.ticketId,
          amount: w.amount,
          currency: w.currency,
          receiptUrl: url,
          note: note || w.savedNote || "",
          paid: false,
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
      return url;
    }

    // group: write receipt to all items
    await Promise.all(
      payload.items.map((w) =>
        setDoc(
          doc(db, "payouts", w.key),
          {
            agentUid: user.uid,
            userUid: w.userUid,
            cardId: w.cardId,
            ticketId: w.ticketId,
            amount: w.amount,
            currency: w.currency,
            receiptUrl: url,
            note: note || w.savedNote || "",
            paid: false,
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        )
      )
    );
    return url;
  }

  async function markPaidFor(mode, payload) {
    if (mode === "single") {
      const w = payload.item;
      await setDoc(
        doc(db, "payouts", w.key),
        {
          agentUid: user.uid,
          userUid: w.userUid,
          cardId: w.cardId,
          ticketId: w.ticketId,
          amount: w.amount,
          currency: w.currency,
          note: note || w.savedNote || "",
          paid: true,
          paidAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
      return 1;
    }

    // group
    await Promise.all(
      payload.items.map((w) =>
        setDoc(
          doc(db, "payouts", w.key),
          {
            agentUid: user.uid,
            userUid: w.userUid,
            cardId: w.cardId,
            ticketId: w.ticketId,
            amount: w.amount,
            currency: w.currency,
            note: note || w.savedNote || "",
            paid: true,
            paidAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
          },
          { merge: true }
        )
      )
    );
    return payload.items.length;
  }

  /* ───────── UI atoms ───────── */
  const WinnerCard = ({ w, onClick }) => (
    <button
      onClick={onClick}
      className="text-left p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700 hover:ring-slate-600 transition"
    >
      <div className="text-sm text-slate-300 flex items-center gap-2">
        <UserIcon className="w-4 h-4" />
        {w.playerName}
      </div>
      {(w.playerEmail || w.playerPhoneE164 || w.playerPhoneDigits) && (
        <div className="text-[11px] text-slate-400 break-all mt-0.5">
          {w.playerEmail || "—"} {" · "}
          {w.playerPhoneE164 || w.playerPhoneDigits || "—"}
        </div>
      )}
      <div className="text-xl font-bold mt-1">
        {money(w.amount, symOf(w.currency))}
      </div>
      <div className="mt-2 text-xs text-slate-400">
        Ticket: <b>{(w.ticketId || "").slice(0, 8)}…</b> · Card:{" "}
        <b>{(w.cardId || "").slice(0, 8)}…</b>
      </div>
      <div className="mt-2 text-xs text-slate-500">Drawn: {ts(w.drawnAt)}</div>
      {w.bank ? (
        <div className="mt-3 text-xs text-slate-300 flex items-center gap-2">
          <Banknote className="w-4 h-4" />
          {w.bank.bankName} · {w.bank.accountName} · {w.bank.accountNumber}
        </div>
      ) : (
        <div className="mt-3 text-xs text-red-300">No bank on file</div>
      )}
    </button>
  );

  const ConsolidatedCard = ({ g, onClick }) => (
    <button
      onClick={onClick}
      className="text-left p-4 rounded-2xl bg-slate-800 ring-1 ring-slate-700 hover:ring-slate-600 transition"
    >
      <div className="text-sm text-slate-300 flex items-center gap-2">
        <UserIcon className="w-4 h-4" />
        {g.playerName}
      </div>
      {(g.playerEmail || g.playerPhoneE164 || g.playerPhoneDigits) && (
        <div className="text-[11px] text-slate-400 break-all mt-0.5">
          {g.playerEmail || "—"} {" · "}
          {g.playerPhoneE164 || g.playerPhoneDigits || "—"}
        </div>
      )}
      <div className="text-xl font-bold mt-1">
        {money(g.totalAmount, symOf(g.currency))}
      </div>
      <div className="mt-2 text-xs text-slate-400">
        {g.items.length} ticket{g.items.length > 1 ? "s" : ""} · Last drawn:{" "}
        {ts(g.lastDrawnAt)}
      </div>
      {g.bank ? (
        <div className="mt-3 text-xs text-slate-300 flex items-center gap-2">
          <Banknote className="w-4 h-4" />
          {g.bank.bankName} · {g.bank.accountName} · {g.bank.accountNumber}
        </div>
      ) : (
        <div className="mt-3 text-xs text-red-300">No bank on file</div>
      )}
    </button>
  );

  /* ───────── render ───────── */
  return (
    <div className="max-w-6xl mx-auto mt-8 md:mt-16 p-4">
      <div className="flex items-center justify-between gap-3 mb-4">
        <h1 className="text-2xl font-bold">Winners</h1>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            className="pl-9 pr-3 py-2 rounded-xl bg-slate-800 text-white ring-1 ring-slate-700 w-72"
            placeholder="Search user, ticket, card…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* CURRENT */}
      <section className="mb-10">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Layers className="w-4 h-4 text-sky-300" />
            <h2 className="text-lg font-semibold">
              Current winners (latest draw)
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentTab("unpaid")}
              className={`px-3 py-1.5 rounded-full text-sm ${
                currentTab === "unpaid"
                  ? "bg-yellow-400 text-black"
                  : "bg-slate-700 text-white"
              }`}
            >
              Unpaid ({curUnpaidGrouped.length})
            </button>
            <button
              onClick={() => setCurrentTab("paid")}
              className={`px-3 py-1.5 rounded-full text-sm ${
                currentTab === "paid"
                  ? "bg-emerald-400 text-black"
                  : "bg-slate-700 text-white"
              }`}
            >
              Paid ({curPaid.length})
            </button>
          </div>
        </div>

        {currentTab === "unpaid" ? (
          curUnpaidGrouped.length ? (
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
              {curUnpaidGrouped.map((g) => (
                <ConsolidatedCard
                  key={g.key}
                  g={g}
                  onClick={() => {
                    setDrawer({ mode: "group", ...g });
                    setNote("");
                  }}
                />
              ))}
            </div>
          ) : (
            <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
              No unpaid winners in the latest draw.
            </div>
          )
        ) : curPaid.length ? (
          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
            {curPaid.map((w) => (
              <WinnerCard
                key={w.key}
                w={w}
                onClick={() => {
                  setDrawer({ mode: "single", item: w });
                  setNote(w.savedNote || "");
                }}
              />
            ))}
          </div>
        ) : (
          <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
            No paid winners recorded for the latest draw yet.
          </div>
        )}
      </section>

      {/* PREVIOUS */}
      <section className="mb-8">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-yellow-300" />
            <h2 className="text-lg font-semibold">Previous draws</h2>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setPrevTab("unpaid")}
              className={`px-3 py-1.5 rounded-full text-sm ${
                prevTab === "unpaid"
                  ? "bg-yellow-400 text-black"
                  : "bg-slate-700 text-white"
              }`}
            >
              Unpaid ({prevUnpaidGrouped.length})
            </button>
            <button
              onClick={() => setPrevTab("paid")}
              className={`px-3 py-1.5 rounded-full text-sm ${
                prevTab === "paid"
                  ? "bg-emerald-400 text-black"
                  : "bg-slate-700 text-white"
              }`}
            >
              Paid ({prevPaid.length})
            </button>
          </div>
        </div>

        {prevTab === "unpaid" ? (
          prevUnpaidGrouped.length ? (
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
              {prevUnpaidGrouped.map((g) => (
                <ConsolidatedCard
                  key={g.key}
                  g={g}
                  onClick={() => {
                    setDrawer({ mode: "group", ...g });
                    setNote("");
                  }}
                />
              ))}
            </div>
          ) : (
            <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
              No unpaid winners from previous draws.
            </div>
          )
        ) : prevPaid.length ? (
          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
            {prevPaid.map((w) => (
              <WinnerCard
                key={w.key}
                w={w}
                onClick={() => {
                  setDrawer({ mode: "single", item: w });
                  setNote(w.savedNote || "");
                }}
              />
            ))}
          </div>
        ) : (
          <div className="p-4 bg-slate-800 rounded-xl text-slate-300">
            No paid winners recorded for previous draws yet.
          </div>
        )}
      </section>

      {/* Drawer (single or group) */}
      {drawer && (
        <div
          className="fixed inset-0 bg-black/50 z-40"
          onClick={() => setDrawer(null)}
        >
          <div
            className="absolute right-0 top-0 h-full w-full max-w-md bg-slate-900 p-5 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-3">
              <div className="text-lg font-semibold">
                {drawer.mode === "group"
                  ? "Pay multiple tickets"
                  : "Winner details"}
              </div>
              <button
                onClick={() => setDrawer(null)}
                className="p-2 rounded bg-slate-800 hover:bg-slate-700"
              >
                <X size={18} />
              </button>
            </div>

            {/* Header */}
            <div className="space-y-1 text-sm text-slate-300 mb-2">
              <div className="font-semibold">
                {drawer.mode === "group"
                  ? drawer.playerName
                  : drawer.item.playerName}
              </div>
              <div className="text-slate-400 text-xs break-all">
                {(drawer.mode === "group"
                  ? drawer.playerEmail
                  : drawer.item.playerEmail) || "—"}{" "}
                {" · "}
                {(drawer.mode === "group"
                  ? drawer.playerPhoneE164 || drawer.playerPhoneDigits
                  : drawer.item.playerPhoneE164 ||
                    drawer.item.playerPhoneDigits) || "—"}
              </div>
            </div>

            {/* Amounts */}
            {drawer.mode === "group" ? (
              <div className="text-xl font-bold">
                {money(drawer.totalAmount, symOf(drawer.currency))}{" "}
                <span className="text-sm text-slate-400 font-medium">
                  ({drawer.items.length} ticket
                  {drawer.items.length > 1 ? "s" : ""})
                </span>
              </div>
            ) : (
              <div className="text-xl font-bold">
                {money(drawer.item.amount, symOf(drawer.item.currency))}
              </div>
            )}

            {/* Bank */}
            <div className="mt-3">
              <div className="text-sm font-semibold mb-1">Bank details</div>
              {(drawer.mode === "group" ? drawer.bank : drawer.item.bank) ? (
                <div className="p-3 rounded-xl bg-slate-800 ring-1 ring-slate-700 text-sm">
                  <div>
                    {
                      (drawer.mode === "group" ? drawer.bank : drawer.item.bank)
                        .bankName
                    }
                  </div>
                  <div>
                    {
                      (drawer.mode === "group" ? drawer.bank : drawer.item.bank)
                        .accountName
                    }
                  </div>
                  <div>
                    {
                      (drawer.mode === "group" ? drawer.bank : drawer.item.bank)
                        .accountNumber
                    }
                  </div>
                  {(drawer.mode === "group" ? drawer.bank : drawer.item.bank)
                    .branch ? (
                    <div>
                      {
                        (drawer.mode === "group"
                          ? drawer.bank
                          : drawer.item.bank
                        ).branch
                      }
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="text-red-300 text-sm">
                  No bank on file for this user.
                </div>
              )}
            </div>

            {/* Breakdown (group) */}
            {drawer.mode === "group" && (
              <div className="mt-4">
                <div className="text-sm font-semibold mb-1">Tickets to pay</div>
                <div className="space-y-2">
                  {drawer.items.map((w) => (
                    <div
                      key={w.key}
                      className="p-2 rounded-xl bg-slate-800 ring-1 ring-slate-700 text-xs"
                    >
                      <div className="flex items-center justify-between">
                        <span>
                          Ticket <b>{w.ticketId.slice(0, 8)}…</b> · Card{" "}
                          <b>{w.cardId.slice(0, 8)}…</b>
                        </span>
                        <span className="font-semibold">
                          {money(w.amount, symOf(w.currency))}
                        </span>
                      </div>
                      <div className="text-slate-500 mt-1">
                        Drawn: {ts(w.drawnAt)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Receipt */}
            <div className="mt-4">
              <div className="text-sm font-semibold mb-1">Payout receipt</div>
              <div className="p-3 rounded-xl bg-slate-800 ring-1 ring-slate-700">
                {/* show link only for single (for group we can’t know “the” link unless we uploaded one now) */}
                {drawer.mode === "single" && drawer.item.receiptUrl ? (
                  <a
                    href={drawer.item.receiptUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 text-slate-300 hover:underline"
                  >
                    <ImageIcon size={16} />
                    View current receipt
                  </a>
                ) : (
                  <div className="text-slate-400 text-sm">
                    {drawer.mode === "group"
                      ? "No shared receipt yet."
                      : "No receipt uploaded yet."}
                  </div>
                )}

                <label className="mt-3 inline-flex items-center gap-2 px-3 py-2 rounded bg-indigo-400 text-black font-semibold cursor-pointer">
                  <UploadCloud size={16} />
                  {uploading ? "Uploading…" : "Upload"}
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      try {
                        setUploading(true);
                        const url = await uploadReceiptFor(
                          drawer.mode,
                          drawer.mode === "group"
                            ? drawer
                            : { item: drawer.item, key: drawer.item.key },
                          file
                        );
                        if (drawer.mode === "single") {
                          setDrawer((d) => ({
                            ...d,
                            item: { ...d.item, receiptUrl: url },
                          }));
                        }
                        toast.success("Receipt uploaded");
                      } catch (err) {
                        console.error(err);
                        toast.error("Upload failed");
                      } finally {
                        setUploading(false);
                      }
                    }}
                    disabled={uploading}
                  />
                </label>
              </div>
            </div>

            {/* Note */}
            <div className="mt-4">
              <div className="text-sm font-semibold mb-1">Note (optional)</div>
              <textarea
                className="w-full min-h-[80px] p-3 rounded-xl bg-slate-800 text-white ring-1 ring-slate-700"
                placeholder="e.g., Sent via bank transfer. Ref #1234"
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>

            {/* Actions */}
            <div className="mt-4 flex items-center gap-2">
              <button
                onClick={async () => {
                  try {
                    const count = await markPaidFor(
                      drawer.mode,
                      drawer.mode === "group"
                        ? drawer
                        : { item: drawer.item, key: drawer.item.key }
                    );
                    toast.success(
                      drawer.mode === "group"
                        ? `Marked ${count} ticket${
                            count > 1 ? "s" : ""
                          } as paid`
                        : "Marked as paid"
                    );
                    setDrawer(null);
                    setNote("");
                  } catch (e) {
                    console.error(e);
                    toast.error("Failed to mark as paid");
                  }
                }}
                className="px-4 py-2 rounded-xl bg-emerald-400 text-black font-semibold"
              >
                {drawer.mode === "group"
                  ? "Mark All as Paid & Save"
                  : "Mark as Paid & Save"}
              </button>
              <button
                onClick={() => setDrawer(null)}
                className="px-4 py-2 rounded-xl bg-slate-700 text-white"
              >
                Close
              </button>
            </div>

            <div className="text-xs text-slate-500 mt-3">
              Tip: you can upload one receipt and apply it to all tickets in
              this payout group.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
